export const registrationForms = [
  { name: 'account', label: 'Account', isCompleted: false, value: 10 },
  { name: 'identification', label: 'Identification', isCompleted: false, value: 10 },
  { name: 'employment', label: 'Employment', isCompleted: false, value: 10 },
  { name: 'trusted-contact', label: 'Trusted Contact', isCompleted: false, value: 8 },
  { name: 'association', label: 'Association', isCompleted: false, value: 9 },
  { name: 'trading', label: 'Trading', isCompleted: false, value: 10 },
  { name: 'objective', label: 'Objective', isCompleted: false, value: 10 },
  {
    name: 'customer-account-agreement',
    label: 'Customer Account Agreement',
    isCompleted: false,
    value: 10,
  },
  { name: 'disclosures', label: 'Disclosures', isCompleted: false, value: 10 },
  { name: 'submit', label: 'Submit', isCompleted: false, value: 0 },
];

export const defaultAccountData = {
  accountId: 0,
  correspondent: '',
  accountType: 'I',
  subType: '',
  accountName: '',
  tin: '',
  jointOwner: {},
  primaryOwner: {
    identification: {},
  },
  corpOwners: [],
};

export const defaultValidation = {
  primaryOwner: {},
  trustedContact: {},
  jointOwner: {},
};

export const defaultErrorMessage = {
  title: '',
  msg: '',
  errMsg: '',
};
